import { render } from "./RouterButton.vue?vue&type=template&id=15cc719a&scoped=true"
import script from "./RouterButton.vue?vue&type=script&lang=js"
export * from "./RouterButton.vue?vue&type=script&lang=js"

import "./RouterButton.vue?vue&type=style&index=0&id=15cc719a&scoped=true&lang=css"

import exportComponent from "/Users/adamchaarawi/Desktop/dev/adams-personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cc719a"]])

export default __exports__